import { useMemo } from "react";
import { ageFromYmd, findByKeywords } from "../utils/occupation";
import { AgeOccupationRule } from "../types/ageOccupationRule";
import { OptionType } from "../components/booking/information/FormSelect";

type UseAutoJobOpts = {
  occupationOptions: OptionType[];
  dob: string | undefined;
  rules: AgeOccupationRule[];
  mode?: "value" | "label";
};

export function useSuggestedJobValue({
  dob,
  occupationOptions,
  rules,
  mode = "value",
}: UseAutoJobOpts) {
  return useMemo(() => {
    if (!dob) return "";

    const [year, month, day] = dob.split("/").map(Number);
    const date = new Date(year, month - 1, day);

    if (
      !(
        date.getFullYear() === year &&
        date.getMonth() === month - 1 &&
        date.getDate() === day
      )
    ) {
      return "";
    }

    const age = ageFromYmd(dob ?? "");
    if (age == null) return "";

    const rule = rules.find((r) => age >= r.min && age <= r.max);
    if (!rule) return "";

    const matched =
      findByKeywords(occupationOptions, rule.keywords) ??
      findByKeywords(occupationOptions, ["đối tượng khác"]);

    if (!matched) return "";

    return mode === "value" ? String(matched.value) : matched.label;
  }, [dob, occupationOptions, rules, mode]);
}